import { render, staticRenderFns } from "./xcliente.vue?vue&type=template&id=be73f708&scoped=true"
import script from "./xcliente.vue?vue&type=script&lang=js"
export * from "./xcliente.vue?vue&type=script&lang=js"
import style0 from "./xcliente.vue?vue&type=style&index=0&id=be73f708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be73f708",
  null
  
)

export default component.exports